import { MenuItemModel } from "../models/menu-item";
import { procedimientos } from 'src/app/config/procedimientos';
import { rellenarMenUsuario, rellenarMenuAdmin } from './procedimientos_registros';

export var menuItemDataUser: MenuItemModel[] = rellenarMenUsuario();




/* export var menuItemDataUser: MenuItemModel[] = [
     {id: 'inicio', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false, ruta: 'inicio' },
    {id: 'tiritas', icon: 'fa band-aid', text: 'Tiritas',description:'CONTROL DE TIRITAS' ,isSelected: false, ruta: 'tiritas'},
    {id: 'control', icon: 'fa band-aid', text: 'Cristales',description:'CONTROL DE CRISTALES, PLÁSTICOS, LUCES Y METALES',isSelected: false, ruta: 'control'},
    {id: 'limpieza', icon: 'fa band-aid', text: 'Anexo II Control de limpieza y desinfección',description:'Anexo II Control de limpieza y desinfección' ,isSelected: false, ruta: 'limpieza'},
    {id: 'producto', icon: 'fa band-aid', text: 'Anexo III Control de entradas de materia prima',description:'Anexo III Control de entradas de materia prima' ,isSelected: false, ruta: 'producto'},
    {id: 'utensilios', icon: 'fa band-aid', text: 'Utensilios',description:'CONTROL UTENSILIOS Y GRAPAS', isSelected: false, ruta: 'utensilios'},
    {id: 'parametro', icon: 'fa band-aid', text: 'Parámetros', description:'CONTROL DE PARÁMETROS EN CÁMARAS FRIGORÍFICAS',isSelected: false, ruta: 'parametro'},
    {id: 'pesos', icon: 'fa band-aid', text: 'Anexo VII Registro de control de pesos pitufo', description:'Anexo VII Registro de control de pesos pitufo', isSelected: false, ruta: 'pesos'},
    {id: 'girsac', icon: 'fa band-aid', text: 'Anexo VII.bis Registro de control de pesos malla (girsac)', description:'Anexo VII.bis Registro de control de pesos malla (girsac)',isSelected: false, ruta: 'girsac'},
    {id: 'zumos', icon: 'fa band-aid', text: 'Anexo I  Ensayo de contenido en zumos e índice y madurez', description:'Anexo I  Ensayo de contenido en zumos e índice y madurez',isSelected: false, ruta: 'zumos'},
    {id: 'etiquetas', icon: 'fa band-aid', text: 'Etiquetas', description:'CONTROL DE ETIQUETAS',isSelected: false, ruta: 'etiquetas'},
    {id: 'test-de-vida-comercial', icon: 'fa band-aid', text: 'Anexo IV Test de vida comercial', description:'Anexo IV Test de vida comercial',isSelected: false, ruta: 'test-de-vida-comercial'},
    {id: 'control-de-conformidad', icon: 'fa band-aid', text: 'Anexo V Control de conformidad', description:'Anexo V Control de conformidad',isSelected: false, ruta: 'control-de-conformidad'},
    {id: 'transporte', icon: 'fa band-aid', text: 'Anexo IV Datos del transporte', description:'Anexo IV Datos del transporte',isSelected: false, ruta: 'transporte'},
    {id: 'transporte-rutas', icon: 'fa band-aid', text: 'Transporte rutas', description:'TRANSPORTE RUTAS',isSelected: false, ruta: 'transporte-rutas'},
    {id: 'mantenimiento-camiones', icon: 'fa band-aid', text: 'Camiones', description:'MANTENIMIENTO CAMIONES',isSelected: false, ruta: 'mantenimiento-camiones'},
    {id: 'agua-cloro', icon: 'fa band-aid', text: 'Agua cloro', description:'AGUA CLORO',isSelected: false, ruta: 'agua-cloro'},
    {id: 'agua', icon: 'fa band-aid', text: 'Agua', description:'AGUA',isSelected: false, ruta: 'agua'},
    {id: 'limpieza_desinfeccion', icon: 'fa band-aid', text: 'Anexo II.bis Limpieza y desinfección -camiones-', description:'Anexo II.bis Limpieza y desinfección -camiones-',isSelected: false, ruta: 'limpieza_desinfeccion'},
    {id: 'encerado', icon: 'fa band-aid', text: 'Anexo I Control Productos Postcosecha Cera-Online', description:'Anexo I Control Productos Postcosecha Cera-Online',isSelected: false, ruta: 'encerado'},
    {id: 'lavadora', icon: 'fa band-aid', text: 'Anexo II Control Productos Postcosecha Lavadora', description:'Anexo II Control Productos Postcosecha Lavadora',isSelected: false, ruta: 'lavadora'},
    {id: 'etileno', icon: 'fa band-aid', text: 'Anexo IV Control Productos Postcosecha Etileno', description:'Anexo IV Control Productos Postcosecha Etileno',isSelected: false, ruta: 'etileno'},
    {id: 'nebulizador', icon: 'fa band-aid', text: 'Nebulizador', description:'NEBULIZADOR',isSelected: false, ruta: 'nebulizador'},
    {id: 'cuaderno_campo', icon: 'fa band-aid', text: 'Cuaderno de campo', description:'CUADERNO DE CAMPO',isSelected: false, ruta: 'cuaderno_campo'},
    {id: 'confecciones_diarias', icon: 'fa band-aid', text: 'Confección diarias', description:'CONFECCIONES DIARIAS',isSelected: false, ruta: 'confecciones_diarias'},
    {id: 'plagas', icon: 'fa band-aid', text: 'Plagas', description:'Control de plagas',isSelected: false, ruta: 'plagas'},
    {id: 'camaras_etileno', icon: 'fa band-aid', text: 'Cámaras de etileno', description:'Cámaras de etileno',isSelected: false, ruta: 'camaras_etileno'},
    {id: 'residuos_peligrosos', icon: 'fa band-aid', text: 'Anexo I Gestión de residuos', description:'Anexo I Gestión de residuos',isSelected: false, ruta: 'residuos_peligrosos'},
    {id: 'control_linea', icon: 'fa band-aid', text: 'Control línea', description:'Control línea',isSelected: false, ruta: 'control_linea'},
    {id: 'diario_cogida', icon: 'fa band-aid', text: 'Control diario cogida', description:'Control diario cogida',isSelected: false, ruta: 'diario_cogida'},
    {id: 'peso_materia', icon: 'fa band-aid', text: 'Peso entrada materia prima', description:'CONTROL PESO ENTRADA MATERIA PRIMA',isSelected: false, ruta: 'peso_materia'},
    {id: 'perdida_peso_diaria', icon: 'fa band-aid', text: 'Pérdida de peso diaria', description:'PÉRDIDA DIARIA DE PESO EN LA CONFECCIÓN',isSelected: false, ruta: 'perdida_peso_diaria'},
    {id: 'perdida_peso_no_pesada', icon: 'fa band-aid', text: 'Materia prima no pesada', description: 'REGISTRO DE ENTRADA MATERIA PRIMA NO PESADA',isSelected: false, ruta: 'perdida_peso_no_pesada'},
    {id: 'contra_incendios', icon: 'fa band-aid', text: 'Contra incendios', description: 'VERIFICACIÓN INSTALACIONES DE PROTECCION CONTRA INCENDIOS (ANUAL- TRIMESTRAL)',isSelected: false, ruta: 'contra_incendios'},
    {id: 'plan_limpieza_desinfeccion', icon: 'fa band-aid', text: 'Anexo III Plan de limpieza y desinfección', description: 'Anexo III Plan de limpieza y desinfección',isSelected: false, ruta: 'plan_limpieza_desinfeccion'},
    {id: 'reuniones', icon: 'fa band-aid', text: 'Anexo III Listado de reuniones', description: 'Anexo III Listado de reuniones ',isSelected: false, ruta: 'reuniones'},
    {id: 'formacion', icon: 'fa band-aid', text: 'Anexo IV Control de formación', description: 'Anexo IV Control de formación ',isSelected: false, ruta: 'formacion'},
    {id: 'tratamiento_no_conformidad', icon: 'fa band-aid', text: 'Anexo I Tratamiento de las no conformidades', description: 'Anexo I Tratamiento de las no conformidades ',isSelected: false, ruta: 'tratamiento_no_conformidad'},
    {id: 'control_documentos', icon: 'fa band-aid', text: 'Anexo II Control de documentos', description: 'Anexo II Control de documentos',isSelected: false, ruta: 'control_documentos'},
    {id: 'organigrama_funcional', icon: 'fa band-aid', text: 'Organigrama funcional', description: 'Organigrama funcional',isSelected: false, ruta: 'organigrama_funcional'},
    {id: 'encuesta_higiene', icon: 'fa band-aid', text: 'Anexo V Encuesta de higiene', description: 'Anexo V Encuesta de higiene',isSelected: false, ruta: 'encuesta_higiene'},
    {id: 'control_drencher', icon: 'fa band-aid', text: 'Anexo III Control Productos Postcosechal Drencher', description: 'Anexo III Control Productos Postcosechal Drencher',isSelected: false, ruta: 'control_drencher'},
    {id: 'limpieza_cajones', icon: 'fa band-aid', text: 'Registro limpieza cajones', description: 'Registro limpieza cajones',isSelected: false, ruta: 'limpieza_cajones'},
    {id: 'micro_fomesa', icon: 'fa band-aid', text: 'Micro-Fomesa', description: 'Micro-Fomesa',isSelected: false, ruta: 'micro_fomesa'},
    {id: 'multiresiduos', icon: 'fa band-aid', text: 'Multi-residuos', description: 'Multi-residuos',isSelected: false, ruta: 'multiresiduos'},
    {id: 'microbiologico', icon: 'fa band-aid', text: 'Análisis microbiológico', description: 'Análisis microbiológico',isSelected: false, ruta: 'microbiologico'},
    {id: 'fruto_hueso', icon: 'fa band-aid', text: 'Fruto hueso', description: 'Fruto hueso',isSelected: false, ruta: 'fruto_hueso'},
    {id: 'control_auditoria', icon: 'fa band-aid', text: 'Control auditoría', description: 'control_auditoria',isSelected: false, ruta: 'Control auditoría'},
    {id: 'fruto_hueso_no_conformidad', icon: 'fa band-aid', text: 'Fruto hueso no conformidad', description: 'fruto_hueso_no_conformidad',isSelected: false, ruta: 'Fruto hueso no conformidad'},
    {id: 'balance_control', icon: 'fa band-aid', text: 'Balance control de producción diferenciada', description: 'Balance control de producción diferenciada',isSelected: false, ruta: 'balance_control'},
    {id: 'control_certificados', icon: 'fa band-aid', text: 'Control de certificados', description: 'Control de certificados',isSelected: false, ruta: 'control_certificados'},

     
]; */
/* 
Anexo II Control de documentos,
Anexo III Listado de reuniones,
Anexo II Control de limpieza y desinfección,
Anexo II.bis Limpieza y desinfección -camiones-,
Anexo III Plan de limpieza y desinfección,
Anexo V Encuesta de higiene,
Anexo I  Ensayo de contenido en zumos e índice y madurez,
Anexo III Control de entradas de materia prima,
Anexo IV Test de vida comercial,
Anexo V Control de conformidad,
Anexo VII Registro de control de pesos pitufo,
Anexo VII.bis Registro de control de pesos malla (girsac),
Anexo IV Datos del transporte,
Anexo IV Control de formación,
Anexo I Tratamiento de las no conformidades,
Anexo I Control Productos Postcosecha Cera-Online,
Anexo II Control Productos Postcosecha Lavadora,
Anexo III Control Productos Postcosechal Drencher,
Anexo IV Control Productos Postcosecha Etileno
*/

export var menuItemDataAdmin: MenuItemModel[] =  rellenarMenuAdmin();


//console.log(rellenarMenuAdmin());
/*  export var menuItemDataAdmin: MenuItemModel[] = [
    
    {id: 'inicio', icon: 'fa fa-quora', text: 'Inicio' ,description:'Inicio', isSelected: false,ruta: 'inicio' },
    {
        id: 'anexo_1',
        icon: 'fa band-aid',
        text: procedimientos[1][0] + " " + procedimientos[1][1],
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            
            {
                id: 'control_documentos', fatherId: 'anexo_1', text: 'Anexo II Control de documentos', isSelected: false 
            },
            {
                id: 'reuniones', fatherId: 'anexo_1', text: 'Anexo III Listado de reuniones', isSelected: false 
            },
            {
                id: 'control_certificados', fatherId: 'anexo_1', text: 'Control de certificados', isSelected: false 
            }
          
      
        ]
    },
    {
        id: 'anexo_2',
        icon: 'fa band-aid',
        text: 'P.02 LIMPIEZA Y DESINFECCIÓN',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {id: 'limpieza', fatherId: 'anexo_2', text: 'Anexo II Control de limpieza y desinfección', isSelected: false},
            {id: 'limpieza_desinfeccion', fatherId: 'anexo_2', text: 'Anexo II.bis Limpieza y desinfección -camiones-', isSelected: false},
            {id: 'plan_limpieza_desinfeccion', fatherId: 'anexo_2', text: 'Anexo III Plan de limpieza y desinfección', isSelected: false},
            {id: 'encuesta_higiene', fatherId: 'anexo_2', text: 'Anexo V Encuesta de higiene', isSelected: false},
          
        ]
    },
    {
        id: 'anexo_4',
        icon: 'fa band-aid',
        text: 'P.04 CONTROL DE CALIDAD',
        description:'Procedimientos',
        isSelected: false,
        expandable: [
            {id: 'zumos', fatherId: 'anexo_4', text: 'Anexo I  Ensayo de contenido en zumos e índice y madurez', isSelected: false},
            {id: 'producto', fatherId: 'anexo_4', text: 'Anexo III Control de entradas de materia prima', isSelected: false},
            {id: 'test-de-vida-comercial', fatherId: 'anexo_4', text: 'Anexo IV Test de vida comercial', isSelected: false},
            {id: 'control-de-conformidad', fatherId: 'anexo_4', text: 'Anexo V Control de conformidad', isSelected: false},
            {id: 'etiquetas', fatherId: 'anexo_4', text: 'Control de etiquetas', isSelected: false},
            {id: 'pesos', fatherId: 'anexo_4', text: 'Anexo VII Registro de control de pesos pitufo', isSelected: false},
            {id: 'girsac', fatherId: 'anexo_4', text: 'Anexo VII.bis Registro de control de pesos malla (girsac)', isSelected: false},
            {id: '', fatherId: '', text: '', isSelected: false}
          
        ]
        
    },
    {
        id: 'anexo_5',
        icon: 'fa band-aid',
        text: 'P.05 CONTROL DE INFRAESTRUCTURAS, BIENES Y EQUIPOS',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'transporte', fatherId: 'anexo_5', text: 'Anexo IV Datos del transporte', isSelected: false 
            },
           
        ]
    },
    {
        id: 'anexo_9',
        icon: 'fa band-aid',
        text: 'P.09 FORMACIÓN',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'formacion', fatherId: 'anexo_9', text: 'Anexo IV Control de formación', isSelected: false 
            }
           
        ]
    },
    {
        id: 'anexo_14',
        icon: 'fa band-aid',
        text: 'P.14 NO CONFORMIDADES',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'tratamiento_no_conformidad', fatherId: 'anexo_14', text: 'Anexo I Tratamiento de las no conformidades', isSelected: false 
            },
           
        ]
    },
    {
        id: 'anexo_20',
        icon: 'fa band-aid',
        text: 'P.20 GESTIÓN DE RESIDUOS',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
            {
                id: 'residuos_peligrosos', fatherId: 'anexo_20', text: 'Anexo Gestión de residuos', isSelected: false 
            },
           
        ]
    },
    {
        id: 'anexo_22',
        icon: 'fa band-aid',
        text: 'P.22 CONTROL PRODUCTOS POSTCOSECHA',
        description:'Procedimiento',
        isSelected: false,
        expandable: [
/
            {
                id: 'encerado', fatherId: 'anexo_22', text: 'Anexo I Control Productos Postcosecha Cera-Online', isSelected: false 
            },
            {
                id: 'lavadora', fatherId: 'anexo_22', text: 'Anexo II Control Productos Postcosecha Lavadora', isSelected: false 
            },
            {
                id: 'control_drencher', fatherId: 'anexo_22', text: 'Anexo III Control Productos Postcosecha Drencher', isSelected: false 
            },
            {
                id: 'etileno', fatherId: 'anexo_22', text: 'Anexo IV Control Productos Postcosecha Etileno', isSelected: false 
            },
         
            {
                id: '', fatherId: '', text: '', isSelected: false 
            },
           
        ]
    },
    {
        id: 'otros',
        icon: 'fa band-aid',
        text: 'OTROS',
        description:'otros',
        isSelected: false,
        expandable: [
            
            {
                id: 'tiritas', fatherId: 'otros', text: 'Control de tiritas', isSelected: false 
            },
            
            {
                id: 'control', fatherId: 'otros', text: 'Control de cristales, plásticos, luces y metales', isSelected: false 
            },
            {
                id: 'utensilios', fatherId: 'otros', text: 'Control utensilios y grapas', isSelected: false 
            },
            {
                id: 'parametro', fatherId: 'otros', text: 'Control de parámetros en cámaras frigoríficas', isSelected: false 
            },
            
            {
                id: 'transporte-rutas', fatherId: 'otros', text: 'Transporte rutas', isSelected: false 
            },
            {
                id: 'mantenimiento-camiones', fatherId: 'otros', text: 'Mantenimiento camiones', isSelected: false 
            },
            {
                id: 'agua-cloro', fatherId: 'otros', text: 'Agua cloro', isSelected: false 
            },
            {
                id: 'agua', fatherId: 'otros', text: 'Control de Agua', isSelected: false 
            },

            {
                id: 'nebulizador', fatherId: 'otros', text: 'Control de nebulizador', isSelected: false 
            },
            {
                id: 'cuaderno_campo', fatherId: 'otros', text: 'Cuaderno de campo', isSelected: false 
            },
            {
                id: 'confecciones_diarias', fatherId: 'otros', text: 'Confección diarias', isSelected: false 
            },
            {
                id: 'plagas', fatherId: 'otros', text: 'Control de plagas', isSelected: false 
            },
            {
                id: 'camaras_etileno', fatherId: 'otros', text: 'Cámaras de etileno', isSelected: false 
            },
            
            {
                id: 'control_linea', fatherId: 'otros', text: 'Control línea', isSelected: false 
            },
            {
                id: 'diario_cogida', fatherId: 'otros', text: 'Control diario cogida', isSelected: false 
            },
            {
                id: 'peso_materia', fatherId: 'otros', text: 'Control peso entrada materia prima', isSelected: false 
            },
            {
                id: 'perdida_peso_diaria', fatherId: 'otros', text: 'Pérdida diaria de peso en la confección', isSelected: false 
            },
            {
                id: 'perdida_peso_no_pesada', fatherId: 'otros', text: 'Registro de entrada materia prima no pesada', isSelected: false 
            },
            {
                id: 'contra_incendios', fatherId: 'otros', text: 'Verificación instalaciones de proteccion contra incendios (anual- trimestral)', isSelected: false 
            },
         
          
            {
                id: 'organigrama_funcional', fatherId: 'otros', text: 'Organigrama funcional', isSelected: false 
            },

            {
                id: 'limpieza_cajones', fatherId: 'otros', text: 'Registro limpieza cajones', isSelected: false 
            },
            {
                id: 'micro_fomesa', fatherId: 'otros', text: 'Micro-Fomesa', isSelected: false 
            },
            {
                id: 'multiresiduos', fatherId: 'otros', text: 'Multiresiduos', isSelected: false 
            },  
            {
                id: 'microbiologico', fatherId: 'otros', text: 'Análisis microbiológico', isSelected: false 
            }, 
            {
                id: 'fruto_hueso', fatherId: 'otros', text: 'Fruta hueso', isSelected: false 
            }, 
            {
                id: 'control_auditoria', fatherId: 'otros', text: 'Control auditoría', isSelected: false 
            }, 
            {
                id: 'balance_control', fatherId: 'otros', text: 'Balance control de producción diferenciada', isSelected: false 
            }, 

            {
                id: '', fatherId: 'otros', text: '', isSelected: false 
            },
      
          
      
        ]
    },


     
];  */

